<template>
  <div class="outpage">
    <!--    v-loading.fullscreen.lock="loading"-->
    <div class="w100 sta1 flex-cc" v-loading.fullscreen.lock="loading">
      <div class="flex-cc">
        <img class="mlogo1" src="../assets/logo.png" alt="">
        <div class="mlogo2">
          <div class="mlp1">网络空间内生安全知识平台</div>
          <div class="mlp2">KNOWLEDGE SYSTEM OF CYBERSPACE ENDOGENOUS SAFETY&SECURITY</div>
        </div>
      </div>
      <div class="sta3">平台概况</div>
    </div>
    <div class="newstam w100">
      <!--                <video class="videostam" autoplay muted loop>-->
      <!--                  <source src="../assets/image/760.mp4" type="video/mp4">-->
      <!--                </video>-->
      <img class="videostam" src="../assets/1920915.png" alt="">
      <div class="nstam1 flex-hl">

        <div class="w30 nstam2">
          <div class="gedi1 mt10">
            <div class="gedi2">
              <div class="w100 flex-hlc newgebwai">
                <img class="gedi3" src="../assets/img/wenzhang.png" alt="">
                <div class="gedi4">知识类型</div>
                <div class="band1"></div>
              </div>
              <div class="gedi6">
                <div id="echart2"></div>
              </div>
            </div>
          </div>
          <div class="gedi1 mt10">
            <div class="gedi2">
              <div class="w100 flex-hlc newgebwai">
                <img class="gedi3" src="../assets/img/44.png" alt="">
                <div class="gedi4">搜索热点</div>
                <div class="band1"></div>
              </div>
              <div class="gedi6">
                <div id="echartre"></div>
                <!--                <div class="dingre"></div>-->
              </div>
            </div>
          </div>

        </div>
        <div class="w40 nstam3">
          <div class="w100 flex-hlc newgebwai">
            <img class="gedi3 mr10" src="../assets/img/33.png" alt="">
            <div class="gedi4">热点话题</div>
            <div class="band1"></div>
          </div>
          <div class="nstam3-in">
<!--            rr-->
              <vertical-scroll-list :datapagelist="datapagelist"></vertical-scroll-list>
<!--            <vue-seamless-scroll-->
<!--                class="scroll_box"-->
<!--                :data="datapagelist"-->
<!--                :class-option="defineScroll"-->
<!--                style="-->
<!--          height: 100%;-->
<!--          overflow: hidden;-->
<!--          width: 100%;-->
<!--          color: white;-->
<!--          font-size: 18px;-->
<!--          text-align: center;-->
<!--        "-->
<!--            >-->
<!--              <div class="nst-in" v-for="(item,idx) in datapagelist">-->
<!--                <img v-if="idx == 0" class="nstim1" src="../assets/img/NO1.png" alt="">-->
<!--                <img v-if="idx == 1" class="nstim1" src="../assets/img/NO2.png" alt="">-->
<!--                <img v-if="idx == 2" class="nstim1" src="../assets/img/NO3.png" alt="">-->
<!--                <img v-if="idx > 2" class="nstim1-1" :src="require('../assets/num/'+(idx+1)+'.png')" alt="">-->
<!--                <div class="flex-hlc" style="width: calc(100% - 75px)">-->
<!--                  <div class="staimg1">-->
<!--                    <img :src="item.img?item.img:require('../assets/img/zanwu.png')" alt="">-->
<!--                  </div>-->
<!--                  <div style="width: 76%;display: inline-block;float: left;">-->
<!--                    <div class="w100" @click="toarti(item)">-->
<!--                      <el-tooltip class="w100 overflow" effect="dark" :content="item.title" placement="top-start">-->
<!--                        <el-button class="noborder w100">-->
<!--                          {{ item.title }}-->
<!--                        </el-button>-->
<!--                      </el-tooltip>-->
<!--                    </div>-->
<!--                    <div class="wenxiang2 flex-hlc">-->
<!--                      <div>{{ item.gmtCreate }}</div>-->
<!--                      <div class="wms1">|</div>-->
<!--                      <div class="flex-cc">-->
<!--                        <img class="wxim1" src="../assets/img/liulan.png" alt="">-->
<!--                        <span>{{ item.views }}</span>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                    <div class="listz3 over3 w100">{{ item.content }}</div>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--            </vue-seamless-scroll>-->
            <!--            <div class="nst-in" v-for="(item,idx) in datapagelist">-->
            <!--              <img v-if="idx == 0" class="nstim1" src="../assets/img/NO1.png" alt="">-->
            <!--              <img v-if="idx == 1" class="nstim1" src="../assets/img/NO2.png" alt="">-->
            <!--              <img v-if="idx == 2" class="nstim1" src="../assets/img/NO3.png" alt="">-->
            <!--              <img v-if="idx > 2" class="nstim1-1"  :src="require('../assets/num/'+(idx+1)+'.png')" alt="" alt="">-->
            <!--              <div style="display: inline-block;width: calc(100% - 55px)">-->
            <!--                <img style="width: 25%;margin-right:2%;height: 180px;display: inline-block;float: left;" :src="item.img" alt="">-->
            <!--                <div style="width: 73%;display: inline-block;float: left;">-->
            <!--                  <div class="w100" @click="toarti(item)">-->
            <!--                    <el-tooltip class="w100 overflow" effect="dark" :content="title" placement="top-start">-->
            <!--                      <el-button class="noborder w100">-->
            <!--                        {{ item.title }}-->
            <!--                      </el-button>-->
            <!--                    </el-tooltip>-->
            <!--                  </div>-->
            <!--                  <div class="wenxiang2 flex-hlc">-->
            <!--                    <div>{{ item.gmtCreate }}</div>-->
            <!--                    <div class="wms1">|</div>-->
            <!--                    <div class="flex-cc">-->
            <!--                      <img class="wxim1" src="../assets/img/liulan.png" alt="">-->
            <!--                      <span>{{ item.views }}</span>-->
            <!--                    </div>-->
            <!--                  </div>-->
            <!--                  <div class="listz3 over3 w100">{{ item.content }}</div>-->
            <!--                </div>-->
            <!--              </div>-->
            <!--            </div>-->
          </div>
        </div>
        <div class="w30 nstam4">
          <div class="gedi1">
            <div class="gedi2">
              <div class="w100 flex-hlc newgebwai">
                <img class="gedi3 mr10" src="../assets/img/dangrifangwen.png" alt="">
                <div class="gedi4">当日访问人数统计</div>
                <div class="band1"></div>
              </div>
              <div class="gedi6">
                <div id="echart1"></div>
              </div>
            </div>
          </div>
          <div class="gedi1 mt10">
            <div class="gedi2">
              <div class="w100 flex-hlc newgebwai">
                <img class="gedi3" src="../assets/img/luntan.png" alt="">
                <div class="gedi4">工作单位</div>
                <div class="band1"></div>
              </div>
              <div class="gedi9">
                <div id="echart4"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="nst-d70" v-if="knowlook">
          <div class="nst-top flex-hls">
            <div class="flex-hlc">
              <div class="msts1">{{ paramsdata.name }}</div>
              <div class="msts2">{{ dinginfo.name }}</div>
              <div class="msts3">·{{ pageObj.total }}条</div>
            </div>
            <img @click="closeknow" class="msts4" src="../assets/img/close.png" alt="">
          </div>
          <div class="flex-hlc ding-zi">
            <div v-for="(item,index) in dinglist" class="flex-hl fll1 mt10"><span @click="changelei(item)" class="fll3"
                                                                                  :class="[item.id == dingid?'leihot':'']">{{
                item.name
              }}</span><span
                v-if="index != (dinglist.length-1)" class="fll2">|</span></div>
          </div>
          <div class="sta-mid">
            <div class="nst-in flex-hlc flex-box mbom20" v-for="(item,idx) in datalist">
              <img class="nstim2" :src="item.img?item.img:require('../assets/img/zanwu.png')" alt="">
              <div class="nstim3-3">
                <div class="w100" @click="toarti(item)">
                  <el-tooltip class="w100 overflow" effect="dark" :content="item.title" placement="top-start">
                    <el-button class="noborder w100">
                      {{ item.title }}
                    </el-button>
                  </el-tooltip>
                </div>
                <div class="wenxiang2 flex-hlc">
                  {{ item.gmtCreate }}
                </div>
                <div class="listz3 over3 w100">{{ item.content }}</div>
              </div>
            </div>
            <div class="w100 mt20 flex-cc" v-if="datalist.length > 0">
              <el-pagination
                  background
                  layout="prev, pager, next"
                  :current-page.sync="pageObj.currentPage"
                  :page-size="pageObj.pageSize"
                  :total="pageObj.total"
                  @current-change="pageChange">
              </el-pagination>
            </div>
            <div style="width: 100%;height: 20px;"></div>
          </div>
        </div>
      </div>
      <div class="bottomd flex-cc" style="margin-top: -4px;">
        <span>Copyright ◎ 2026 紫金山实验室,All Rights Reserved.</span>
        <span class="shus"></span>
        <img src="../assets/guohui.png" class="jinghui" alt="">
        <span>苏CP备14016373号-4</span>
      </div>
    </div>
    <!--    访问人数-->
    <el-dialog
        title=""
        class="tanpass1-1"
        append-to-body
        :close-on-click-modal="false"
        :visible.sync="recoverlook"
        width="60%">
      <el-table
          :data="pertimelist"
          style="width: 100%">
        <el-table-column
            align="center"
            prop="name"
            label="用户名称">
        </el-table-column>
        <el-table-column
            align="center"
            prop="ip"
            label="用户ip地址">
        </el-table-column>
        <el-table-column
            align="center"
            prop="gmtCreate"
            label="用户登录时间">
        </el-table-column>
        <el-table-column
            align="center"
            prop="unit"
            label="用户工作单位">
        </el-table-column>
      </el-table>
      <div class="w100 mt20 flex-cc" v-if="pertimelist.length > 0">
        <el-pagination
            background
            layout="prev, pager, next"
            :current-page.sync="pageObjday.currentPage"
            :page-size="pageObjday.pageSize"
            :total="pageObjday.total"
            @current-change="pageChangeday">
        </el-pagination>
      </div>
    </el-dialog>
    <el-dialog
        title=""
        class="tanpass1-1"
        append-to-body
        :close-on-click-modal="false"
        :visible.sync="worklook"
        width="60%">
      <el-table
          :data="worklist"
          style="width: 100%">
        <el-table-column
            align="center"
            prop="nickname"
            label="用户名称">
        </el-table-column>
        <el-table-column
            align="center"
            prop="unit"
            label="用户工作单位">
        </el-table-column>
        <el-table-column
            align="center"
            prop="email"
            label="用户邮箱">
        </el-table-column>
        <el-table-column
            align="center"
            prop="area"
            label="地区">
        </el-table-column>
      </el-table>
      <div class="w100 mt20 flex-cc" v-if="worklist.length > 0">
        <el-pagination
            background
            layout="prev, pager, next"
            :current-page.sync="pageObjwork.currentPage"
            :page-size="pageObjwork.pageSize"
            :total="pageObjwork.total"
            @current-change="pageChangework">
        </el-pagination>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {BmlMarkerClusterer} from 'vue-baidu-map'
import VerticalScrollList from '@/components/hanscroll.vue';
export default {
  name: 'statistics',
  components: {
    BmlMarkerClusterer,VerticalScrollList
  },
  data() {
    return {
      // relist:[{name:'基础理论',top:'',left:'',}],
      title: '111111111111111111',
      dinglist: [{name: '1111', id: 1}, {name: '222', id: 2}],
      knowlook: false,
      loading: false,
      recoverlook: false,//人数
      worklook: false,//人数
      tablelist1: [{name: 111}, {name: 22}, {name: 33}, {name: 44}, {name: 55},],
      timenum: 7,
      rebig: '70%',
      radiusin:'45%',
      radiusout:'70%',
      pageObj: {
        pageSize: 10,
        total: 0,
        currentPage: 1
      },
      pageObjday: {//当日访问人数
        pageSize: 10,
        total: 0,
        currentPage: 1
      },
      pageObjwork: {//单位数据分页
        pageSize: 10,
        total: 0,
        currentPage: 1
      },
      MyEcharts1: '',
      MyEcharts2: '',
      MyEcharts3: '',
      MyEchartsre: '',
      MyEcharts4: '',
      MyEcharts5: '',
      paramsdata: '',
      rehot: false,
      parentid: '',//大分类id
      dingid: '',//选中的小分类id
      dinginfo: '',//名称
      datalist: [],//分页数据
      pertimelist: [],//访问人数分页数据
      worklist: [],//数据分页
      pertime: '',//访问人数时间
      workname: '',//单位名称
      pickerPlacement: 'bottom-start',
      sform: {
        time: '',
      },
      echart1: {
        show: true,
      },
      center: {lng: 116.404, lat: 39.915},
      zoom: 2,
      baidulook: false,
      points: [
        {
          lng: 116.404,
          lat: 39.915,
          count: 10,
          iconUrl: require('@/assets/img/redgif.gif'),
          iconWidth: 30,
          iconHeight: 30
        },
        {
          lng: 116.414,
          lat: 39.925,
          count: 5,
          iconUrl: require('@/assets/img/redgif.gif'),
          iconWidth: 30,
          iconHeight: 30
        },
        {
          lng: 116.424,
          lat: 39.935,
          count: 8,
          iconUrl: require('@/assets/img/redgif.gif'),
          iconWidth: 30,
          iconHeight: 30
        },
        {
          lng: 116.434,
          lat: 39.945,
          count: 12,
          iconUrl: require('@/assets/img/redgif.gif'),
          iconWidth: 30,
          iconHeight: 30
        },
        {
          lng: 116.444,
          lat: 39.955,
          count: 6,
          iconUrl: require('@/assets/img/redgif.gif'),
          iconWidth: 30,
          iconHeight: 30
        },
        {
          lng: 117.404,
          lat: 34.915,
          count: 10,
          iconUrl: require('@/assets/img/redgif.gif'),
          iconWidth: 30,
          iconHeight: 30
        },
        {
          lng: 117.414,
          lat: 34.925,
          count: 5,
          iconUrl: require('@/assets/img/redgif.gif'),
          iconWidth: 30,
          iconHeight: 30
        },
        {
          lng: 117.424,
          lat: 34.935,
          count: 8,
          iconUrl: require('@/assets/img/redgif.gif'),
          iconWidth: 30,
          iconHeight: 30
        },
        {
          lng: 117.434,
          lat: 34.945,
          count: 12,
          iconUrl: require('@/assets/img/redgif.gif'),
          iconWidth: 30,
          iconHeight: 30
        },
        {
          lng: 117.444,
          lat: 34.955,
          count: 6,
          iconUrl: require('@/assets/img/redgif.gif'),
          iconWidth: 30,
          iconHeight: 30
        },
      ],
      infoWindow: {
        show: false,
        position: {},
        title: '',
        content: ''
      },
      clusterStyles: [{
        url: require('../assets/img/redgif.gif'),
        size: {width: 30, height: 30},
        textColor: '#fff',
        textSize: 12
      }],
      mousePosition: {},
      safelist: [],
      baidulist: [],
      datapagelist: [],
    }
  },
  computed: {
    defineScroll() {
      return {
        autoPlay: true,//是否自动滚动
        step: 0.5, // 数值越大速度滚动越快
        limitMoveNum: 2, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleHeight: 0,
        // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        singleWidth: 0,
        waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
        userinfo: '',

      };
    },
  },
  mounted() {
      this.userinfo = JSON.parse(localStorage.getItem('muiuserinfo') || '{}')?.userInfo || null
    if(window.innerWidth < 1441){
      this.rebig = '55%';
      this.radiusin = '30%';
      this.radiusout = '55%';//等有数据了测试
    }
    this.getdata();//获取echarts
    // this.gettielist();//获取帖子
    this.getpage();
  },
  methods: {
    // 获取排名分页数据
    getpage() {
      let data = {};
      data.pageNumber = 1;
      data.pageSize = 20;
      data.hot = 1;
      this.$http({
        url: "article/page",
        method: "POST",
        data: this.$form(data)
      }).then(res => {
        res.data.records.forEach((item,idx) => {
          item.newnum = idx;
        })
        this.datapagelist = res.data.records;
        console.log('this.datapagelist',this.datapagelist)
      });
    },
    // 跳转文章详情
    toarti(val) {
      this.$router.push({
        path: '/knowledge',
        query: {
          parentid: val.categoryPid,//父级id
          id: val.categoryId,//分类id
          artiid: val.id,
        }
      })
    },
    closeknow() {
      this.knowlook = false;
      this.rehot = false;
    },
    pageChange(page) {
      console.log('页码', page)
      this.pageObj.currentPage = page;
      this.getinfolist();
    },
    pageChangeday(page) {
      console.log('页码', page)
      this.pageObjday.currentPage = page;
      this.gettimelist();
    },
    pageChangework(page) {
      console.log('页码', page)
      this.pageObjwork.currentPage = page;
      this.getworklist();
    },
    changelei(val) {
      this.dingid = val.id;
      this.dinginfo = val;
      this.rehot = false;
      this.datalist = [];
      this.pageObj = {
        pageSize: 10,
        total: 0,
        currentPage: 1
      }
      this.getinfolist();
    },
    mapReady({BMap, map}) {
      console.log('地图初始化完成')
    },
    updateCustomWindowPosition(e) {
      console.log('e.offsetX', e.offsetX, e.offsetY)
      // 记录鼠标位置用于定位自定义窗口
      this.mousePosition = {x: e.offsetX, y: e.offsetY}
    },
    showInfoWindow(point, index) {
      const mousePosition = this.mousePosition || {x: 0, y: 0}
      this.infoWindow = {
        show: true,
        position: {x: mousePosition.x + 10, y: mousePosition.y + 10},
        // position: {lng: point.lng, lat: point.lat},
        // title: `位置 ${index + 1}`,
        content: `${point.count}人`
      }
    },
    hideInfoWindow() {
      this.infoWindow.show = false
    },
    changetime(val) {
      this.timenum = val;
      // this.gettielist();
    },
    subsear() {
      console.log(this.sform)
      // this.gettielist();
    },
    resetsear() {
      this.timenum = 7;
      this.sform = {
        time: '',
      }
      // this.gettielist();
    },
    //
    gettielist() {
      let data = JSON.parse(JSON.stringify(this.sform));
      data.time = data.time && data.time.length == 2 ? (this.$timeDay(data.time[0], 1) + '~' + this.$timeDay(data.time[1], 1)) : '';
      data.day = 30;
      this.$http({
        url: "statistics/post",
        method: "POST",
        data: this.$form(data)
      }).then(res => {
        console.log('帖子', res.data)
        let dataname = res.data.map(item => item.name);
        let dataval = res.data.map(item => item.value);
        let option4 = {}
        const gradientColor = {
          type: 'linear',       // 线性渐变
          x: 0, y: 0,           // 渐变起点（左上角）
          x2: 0, y2: 1,         // 渐变终点（左下角，垂直方向）
          colorStops: [
            {offset: 0, color: '#07CDFF'},  // 顶部颜色（0%位置）
            {offset: 1, color: '#FFFFFF'}   // 底部颜色（100%位置）
          ]
        }
        option4 = {
          xAxis: {
            type: 'category',
            axisLine: {show: false}, // 隐藏轴线
            axisTick: {show: false}, // 隐藏刻度线
            // data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
            data: dataname,
            axisLabel: {
              show: true,  // 显示X轴文字
              color: '#fff', // X轴文字颜色
              fontSize: 12
            },
          },
          yAxis: {
            type: 'value',
            axisLabel: {
              show: true,  // 显示X轴文字
              color: '#fff', // X轴文字颜色
              fontSize: 12
            },
            splitLine: {
              lineStyle: {
                color: ['#516D9E'], // 设置网格线颜色
                width: 1,
                type: 'solid'
              }
            }
          },
          grid: {
            left: '0%',
            right: '3%',
            top: '20%',
            bottom: '0%',
            containLabel: true
          },
          series: [
            {
              // data: [120, 200, 150, 80, 70, 110, 130],
              data: dataval,
              type: 'bar',
              barWidth: 20,
              // 顶部数值配置（核心）
              label: {
                show: true,         // 始终显示
                position: 'top',    // 显示在柱子顶部
                distance: 5,        // 与柱子顶部的距离
                textStyle: {
                  color: '#fff',    // 数值颜色
                  fontSize: 14,     // 数值大小
                  // fontWeight: 'bold' // 加粗显示
                },
                // // 格式化数值，可添加单位
                // formatter: function(params) {
                //   return params.value; // 直接显示数值，可改为 `${params.value} 件` 等
                // }
              },
              // 圆角设置
              itemStyle: {
                borderRadius: [18, 18, 18, 18],  // [上左, 上右, 下右, 下左]
                color: gradientColor         // 应用渐变色
              },
            }
          ]
        };
        this.MyEcharts4 = this.$echarts.init(document.getElementById("echart4"));
        this.MyEcharts4.setOption(option4, true); //设置为true可以是图表切换数据时重新渲染
        window.addEventListener("resize", () => {
          this.MyEcharts4.resize();
        });
      });

    },
    // 饼图点击
    handlePieClick(params) {
      console.log('饼图点击参数:', params.data)
      this.paramsdata = params.data;
      this.parentid = params.data.id;
      // if (!this.userinfo) {
      //   this.$message({
      //     message: '请先进行登录再进行操作！',
      //     type: 'warning',
      //     duration: 2000
      //   });
      //   return false;
      // }
      // if (this.userinfo && !this.userinfo.roleId) {
      //   this.$message({
      //     message: '暂无角色，请联系管理员！',
      //     type: 'warning',
      //     duration: 2000
      //   });
      //   return false;
      // }
      this.$router.push({
        path: 'knowledge',
        query: {
          parentid: params.data.id,
          // pushnum:this.randomnum()
        }
      })
      // this.rehot = false;
      // this.dingid = '';
      // this.datalist = [];
      // this.pageObj = {
      //   pageSize: 10,
      //   total: 0,
      //   currentPage: 1
      // }
      // this.loading = true;
      // this.getlist()
    },
    // 人数点击 ppp
    handlepeoplelick(params) {
      console.log('饼图点击参数:', params)
      this.pertime = params.name;
      this.pertimelist = [];
      this.pageObjday = {
        pageSize: 10,
        total: 0,
        currentPage: 1
      }
      this.gettimelist()
      this.loading = true;
    },
    // 工作点击 www
    handleworklick(params) {
      console.log('饼图点击参数:', params)
      this.workname = params.name;
      this.worklist = [];
      this.pageObjwork = {
        pageSize: 10,
        total: 0,
        currentPage: 1
      }
      this.getworklist();
      this.loading = true;
    },
    // 获取分页数据
    gettimelist() {
      let data = {};
      data.pageNumber = this.pageObjday.currentPage;
      data.pageSize = this.pageObjday.pageSize;
      data.hour = this.pertime ? this.pertime : '';
      this.$http({
        url: "user/login/page",
        method: "POST",
        data: this.$form(data)
      }).then(res => {
        this.pageObjday.total = res.data.total;
        this.pertimelist = res.data.records;
        this.recoverlook = true;
        this.loading = false;
      }).catch(err => {
        this.loading = false;
      })
    },
    // 获取分页数据
    getworklist() {
      let data = {};
      data.pageNumber = this.pageObjwork.currentPage;
      data.pageSize = this.pageObjwork.pageSize;
      data.unit = this.workname ? this.workname : '';
      this.$http({
        url: "user/page",
        method: "POST",
        data: this.$form(data)
      }).then(res => {
        this.pageObjwork.total = res.data.total;
        // this.pageObjwork.total =100;
        this.worklist = res.data.records;
        this.worklook = true;
        this.loading = false;
      }).catch(err => {
        this.loading = false;
      })
    },
    //获取顶部小分类列表
    getlist() {
      let data = {
        pid: this.parentid
      }
      this.$http({
        url: 'category/list',
        method: 'post',
        data: this.$form(data)
      }).then((res) => {
        this.dinglist = res.data;
        if (!res.data || res.data.length == 0) {
          this.loading = false;
          return
        } else {
          if (!this.dingid) {
            this.dinginfo = res.data[0];
            this.dingid = res.data ? res.data[0].id : '';//如果没有id用第一个当id
          }
          this.getinfolist();//获取分页数据4
        }
        this.loading = false;
      }).catch(err => {
        this.loading = false;
      })
    },
    // 获取分页数据
    getinfolist() {
      let data = {};
      data.pageNumber = this.pageObj.currentPage;
      data.pageSize = this.pageObj.pageSize;
      data.categoryId = this.dingid ? this.dingid : '';
      data.searchHot = this.rehot ? 1 : 0;
      this.$http({
        url: "article/page",
        method: "POST",
        data: this.$form(data)
      }).then(res => {
        this.pageObj.total = res.data.total;
        this.datalist = res.data.records;
        this.knowlook = true;
        this.loading = false;
      }).catch(err => {
        this.loading = false;
      })
    },
    // 饼图点击
    reclick(params) {
      console.log('params', params)
      // this.rehot = true;
      // this.paramsdata = params.data;
      // this.parentid = params.data.id;
      // this.dingid = '';
      // this.dinginfo = '';
      // this.datalist = [];
      // this.pageObj = {
      //   pageSize: 10,
      //   total: 0,
      //   currentPage: 1
      // }
      // this.loading = true;
      // this.getlist()
    },
    getdata() {
      let data = {}
      this.$http({
        url: "statistics/data",
        method: "POST",
        data: data
      }).then(res => {
        console.log('数据', res.data)
        this.safelist = res.data.data5;
        let allnum = 0;
        if (res.data.data2) {
          res.data.data2.forEach(item => {
            allnum += Number(item.value);
          })
        }
        if (res.data.data4) {
          res.data.data4.forEach(item => {
            item.iconUrl = require('@/assets/img/redgif.gif');
            item.iconWidth = 30;
            item.iconHeight = 30;
          })
          this.baidulist = res.data.data4;
          this.baidulook = true;
          console.log('this.baidulist', this.baidulist)
        }
        let data1 = res.data.data1.map(item => item.name);
        let data12 = res.data.data1.map(item => item.value);
        let option1 = {}
        option1 = {
          xAxis: {
            type: 'category',
            axisLine: {show: false}, // 隐藏轴线
            axisTick: {show: false}, // 隐藏刻度线
            axisLabel: {
              show: true,  // 显示X轴文字
              color: '#fff', // X轴文字颜色
              fontSize: 12
            },
            // axisLabel: { show: false }, // 隐藏轴标签文字
            // splitLine: { show: false }, // 隐藏 X 轴方向网格线
            // data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
            data: data1
          },
          yAxis: {
            type: 'value',
            axisLine: {show: false}, // 隐藏轴线
            axisTick: {show: false}, // 隐藏刻度线
            axisLabel: {
              show: true,  // 显示X轴文字
              color: '#fff', // X轴文字颜色
              fontSize: 12
            },
            splitLine: {
              lineStyle: {
                color: ['#516D9E'], // 设置网格线颜色
                width: 1,
                type: 'solid'
              }
            }
          },
          grid: {
            left: '0%',
            right: '3%',
            top: '10%',
            bottom: '0%',
            containLabel: true
          },
          series: [
            {
              // data: [150, 230, 224, 218, 135, 147, 260],
              data: data12,
              type: 'line',
              lineStyle: {
                color: '#00FF8A', // 折线颜色（可自定义，如 #FF6B6B、#4ECDC4）
                width: 3 // 折线宽度
              },
              itemStyle: {
                color: '#00FF8A' // 标记点颜色（与折线保持一致）
              },

              // 始终显示数值
              label: {
                show: true, // 一直显示
                position: 'top', // 显示在柱形上方
                formatter: '{c}', // 格式化显示内容，{c}表示数据值
                textStyle: {
                  color: '#FFF',
                  fontSize: 14
                }
              },
            }
          ]
        };
        this.MyEcharts1 = this.$echarts.init(document.getElementById("echart1"));
        this.$nextTick(() => {
          // 监听饼图点击事件
          this.MyEcharts1.on('click', (params) => {
            this.handlepeoplelick(params)
          })
        })
        // this.MyEcharts1.clear(); //适用于大数据量的切换时图表绘制错误,先清空在重绘
        let currentColors = ['#785DB0', '#FB628B', '#FFD10A', '#0CA8DF', '#FF994D', '#505372', '#B6D634', '#5070DD', '#3FBE95',]
        let option2 = {}
        let data2 = res.data.data2;
        option2 = {
          graphic: [
            {
              type: 'text',
              left: 'center', // 水平居中
              top: '42%', // 垂直位置（偏上）
              style: {
                text: allnum,
                fontSize: 24, // 第一行字体小（14px）
                fontWeight: 'normal',
                fill: '#fff',
                textAlign: 'center'
              }
            },
            // 第二行文字：“100”（大字体，突出显示）
            {
              type: 'text',
              left: 'center', // 水平居中（与第一行对齐）
              top: '56%', // 垂直位置（偏下，与第一行间距6%）
              style: {
                text: '总数量',
                fontSize: 14, // 第二行字体大（24px）
                fontWeight: 'bold',
                fill: '#fff',
                textAlign: 'center'
              }
            }
          ],
          series: [
            {
              name: 'Access From',
              type: 'pie',
              radius: [this.radiusin, this.radiusout],
              center: ['50%', '50%'],
              avoidLabelOverlap: false,
              padAngle: 5,
              labelLine: {
                show: true
              },
              itemStyle: {
                borderRadius: 5,
                color: function (params) {
                  // 循环使用颜色数组
                  return currentColors[params.dataIndex % currentColors.length];
                }
              },
              label: {
                normal: {
                  // show: false,
                  // formatter: '{b}:'+'\n'+'{c}'+'\n'+'{d}%',
                  formatter: '{b}:' + '\n' + '{c}' + '(' + '{d}%' + ')',
                  avoidLabelOverlap: true,//避免标签重叠
                  textStyle: {
                    fontWeight: 'normal',
                    fontSize: 12,
                    color: '#fff'
                  }
                }
              },
              data: data2
            }
          ]
        };
        this.MyEcharts2 = this.$echarts.init(document.getElementById("echart2"));
        this.$nextTick(() => {
          // 监听饼图点击事件
          this.MyEcharts2.on('click', (params) => {
            this.handlePieClick(params)
          })
        })

        let dataname = res.data.data7.map(item => item.name);
        let dataval = res.data.data7.map(item => item.value);
        let option4 = {}
        const gradientColor = {
          type: 'linear',       // 线性渐变
          x: 0, y: 0,           // 渐变起点（左上角）
          x2: 0, y2: 1,         // 渐变终点（左下角，垂直方向）
          colorStops: [
            {offset: 0, color: '#07CDFF'},  // 顶部颜色（0%位置）
            {offset: 1, color: '#FFFFFF'}   // 底部颜色（100%位置）
          ]
        }
        option4 = {
          xAxis: {
            type: 'category',
            axisLine: {show: false}, // 隐藏轴线
            axisTick: {show: false}, // 隐藏刻度线
            // data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
            data: dataname,
            axisLabel: {
              show: true,  // 显示X轴文字
              color: '#fff', // X轴文字颜色
              fontSize: 12
            },
          },
          yAxis: {
            type: 'value',
            axisLabel: {
              show: true,  // 显示X轴文字
              color: '#fff', // X轴文字颜色
              fontSize: 12
            },
            splitLine: {
              lineStyle: {
                color: ['#516D9E'], // 设置网格线颜色
                width: 1,
                type: 'solid'
              }
            }
          },
          grid: {
            left: '0%',
            right: '3%',
            top: '20%',
            bottom: '0%',
            containLabel: true
          },
          series: [
            {
              // data: [120, 200, 150, 80, 70, 110, 130],
              data: dataval,
              type: 'bar',
              barWidth: 20,
              // 顶部数值配置（核心）
              label: {
                show: true,         // 始终显示
                position: 'top',    // 显示在柱子顶部
                distance: 5,        // 与柱子顶部的距离
                textStyle: {
                  color: '#fff',    // 数值颜色
                  fontSize: 14,     // 数值大小
                  // fontWeight: 'bold' // 加粗显示
                },
                // // 格式化数值，可添加单位
                // formatter: function(params) {
                //   return params.value; // 直接显示数值，可改为 `${params.value} 件` 等
                // }
              },
              // 圆角设置
              itemStyle: {
                borderRadius: [18, 18, 18, 18],  // [上左, 上右, 下右, 下左]
                color: gradientColor         // 应用渐变色
              },
            }
          ]
        };
        this.MyEcharts4 = this.$echarts.init(document.getElementById("echart4"));
        this.MyEcharts4.setOption(option4, true); //设置为true可以是图表切换数据时重新渲染
        this.$nextTick(() => {
          // 监听饼图点击事件
          this.MyEcharts4.on('click', (params) => {
            this.handleworklick(params)
          })
        })
        window.addEventListener("resize", () => {
          this.MyEcharts4.resize();
        });


        let optionre = {}
        let datere = res.data.data6;
        // optionre = {
        //   series: [
        //     {
        //       name: 'Nightingale Chart',
        //       type: 'pie',
        //       radius: [40, 121],
        //       center: ['50%', '50%'],
        //       roseType: 'area',
        //       itemStyle: {
        //         borderRadius: 8
        //       },
        //       label: {
        //         normal: {
        //           // show: false,
        //           // formatter: '{b}:'+'\n'+'{c}'+'\n'+'{d}%',
        //           formatter: '{b}:' + '\n' + '{c}' + '(' + '{d}%' + ')',
        //           avoidLabelOverlap: true,//避免标签重叠
        //           textStyle: {
        //             fontWeight: 'normal',
        //             fontSize: 12,
        //             color: '#fff'
        //           }
        //         }
        //       },
        //       data: datere
        //     }
        //   ]
        // };
        let inlist = [];
        let datare = [];
        if (res.data.data6) {
          res.data.data6.forEach(item => {
            inlist.push({name: item.name + '\n' + item.value + '(' + item.rate + '%)', max: res.data.smax});
            datare.push(item.value);
          })
        }
        console.log('datare', datare, inlist)
        optionre = {
          title: {
            text: ''
          },
          confine: true, // 限制在图表区域内
          // tooltip: {
          //   trigger: 'item', // 触发方式
          //   formatter: '{c}',
          //   // formatter: function(params) {
          //   //   const param = params[0];
          //   //   console.log('paramparamparam',param)
          //   //   return `${param.axisValue}: ${param.value}`
          //   // }
          // },
          radar: {
            // shape: 'circle',
            radius:this.rebig,           // 控制雷达图大小
            center: ['50%', '50%'],  // 控制雷达图位置
            indicator: inlist,
            axisName: {
              color: '#fff',
              fontSize: 14,
              // backgroundColor: 'rgba(255,255,255,0.9)',
              padding: 0,
              borderRadius: 4,
              // borderColor: '#409EFF',
              borderWidth: 0
            }
          },
          series: [
            {
              name: 'Budget vs spending',
              type: 'radar',
              symbol: 'none', // 取消视觉上的标记点
              symbolSize: 0,
              // 但保留悬停区域
              emphasis: {
                scale: false,
                focus: 'series'
              },
              data: [
                {
                  value: datare,
                  name: '',
                  lineStyle: {
                    color: '#F174B6',      // 线条颜色
                    width: 2,              // 线条宽度
                    type: 'solid'          // 线条类型
                  },
                  // 填充区域
                  areaStyle: {
                    color: this.$echarts.graphic.RadialGradient(0.1, 0.6, 1, [
                      {
                        color: 'rgba(241,116,182, 0.1)',
                        offset: 0
                      },
                      {
                        color: 'rgba(241,116,182, 1)',
                        offset: 1
                      }
                    ])
                  }
                }
              ]
            }
          ]
        };

        this.MyEchartsre = this.$echarts.init(document.getElementById("echartre"));
        this.$nextTick(() => {
          // 监听饼图点击事件
          this.MyEchartsre.on('click', (params) => {
            this.reclick(params)
          })
        })
        // // 自定义tooltip显示
        // this.MyEchartsre.on('mousemove', (params) => {
        //   if (params.dataIndex !== undefined) {
        //     const indicator = optionre.radar.indicator[params.dataIndex]
        //     const value = optionre.series[0].data[0].value[params.dataIndex]
        //     console.log(indicator,value)
        //     // 显示自定义提示
        //     this.MyEchartsre.dispatchAction({
        //       type: 'showTip',
        //       seriesIndex: 0,
        //       dataIndex: params.dataIndex
        //     })
        //   }
        // })
        this.$nextTick(() => {
          this.MyEcharts1.setOption(option1, true); //设置为true可以是图表切换数据时重新渲染
          window.addEventListener("resize", () => {
            this.MyEcharts1.resize();
          });
          this.MyEcharts2.setOption(option2, true); //设置为true可以是图表切换数据时重新渲染
          window.addEventListener("resize", () => {
            this.MyEcharts2.resize();
          });
          this.MyEchartsre.setOption(optionre, true); //设置为true可以是图表切换数据时重新渲染
          window.addEventListener("resize", () => {
            this.MyEchartsre.resize();
          });
          // this.MyEcharts3.setOption(option3, true); //设置为true可以是图表切换数据时重新渲染
          // console.log(this.MyEcharts3.getOption())
          // window.addEventListener("resize", () => {
          //   this.MyEcharts3.resize();
          // });
        })
      });


    },
  },

}
</script>
<!--打包放开加上333-->

<style lang="scss" scoped>
.staimg1 {
  width: 22%;
  margin-right: 2%;
  //max-height: 180px;
  max-height: 180px;
  display: inline-block;
  float: left;
  img{
    width: 100%;
    height: auto;
    max-height: 180px;
  }
}
@media screen and (max-width: 1440px) {
  .over3{
    font-size: 15px !important;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2 !important;
    line-height: 1em !important;
    max-height: calc(2 * 1em) !important; /* 3行半高度 */
  }
}
</style>
<style lang="scss">

.anchorBL {
  display: none !important;
}

.el-table__empty-block {
  background-color: #0B3E73;
  color: white !important;
}

.el-table__empty-text {
  color: white !important;
}

/* 自定义信息窗口样式 */
.custom-info-window {
  position: absolute;
  background: rgba(1, 3, 6, 0.8);
  color: white;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  border: 1px solid #e5e7eb;
  z-index: 1000;
  max-width: 50px;
  min-width: 50px;
  text-align: center;
  padding: 8px 10px;
  font-size: 12px;
  line-height: 1.3;
  animation: fadeIn 0.2s ease-out;
}


.gedilan {
  color: #0090FF !important;
}

.videostam {
  width: 100%;
  height: calc(100vh - 160px);
  object-fit: cover;
}
</style>
<!---->
<style scoped lang="scss">
.tanpass1-1 {
  /deep/ {
    .el-dialog__headerbtn .el-dialog__close {
      color: white;
    }

    .el-table th.el-table__cell {
      background-color: #0B3E73;
      color: white !important;
    }

    .el-table--enable-row-transition .el-table__body td.el-table__cell {
      background-color: #0B3E73;
      color: white !important;
    }

    .el-dialog {
      border-radius: 16px;
    }

    .el-dialog__body {
      background: #0B3E73;
      border-radius: 0 0 15px 15px;
    }

    .el-dialog__header {
      background: #0B3E73;
      border-radius: 15px 15px 0 0;
    }
  }
}

.leihot {
  color: #0090FF;
}

.wenxiang2 {
  margin-top: 15px;
  margin-bottom: 15px;
}

.listz3 {
  color: white;
}

.nstim1 {
  width: 50px;
  //height: 54px;
  height: max-content;
  display: inline-block;
  float: left;
  margin-right: 5px;
}

.nstim1-1 {
  width: 50px;
  //height: 54px;
  height: max-content;
  //margin-right: 10px;
  display: inline-block;
  float: left;
  //box-shadow: 0 8px 6px -6px rgba(255,213,166, 0.5), /* 上方阴影 */
  //-8px 0 6px -6px rgba(255,213,166, 0.5), /* 左侧阴影 */
  //8px 0 6px -6px rgba(255,213,166, 0.5), /* 右侧阴影 */
  //0 -8px 6px -6px rgba(255,213,166, 0.5); /* 下方阴影 */
}

.nstim2 {
  width: 240px;
  height: 180px;
  margin-right: 20px;
}

.nstim3-3 {
  width: calc(100% - 280px);
}

.nstim3 {
  width: 413px;
}

.noborder {
  border: none !important;
  padding: 0 !important;
  color: white !important;
  text-decoration: none;
  background-color: transparent !important;
  text-align: left !important;
  font-size: 24px !important;
  font-weight: bold;
}

.noborder:hover {
  background: none;
  color: #0090FF !important;
}

.gedi4 {
  font-size: 18px;
  color: white;
  font-weight: bold;
}

.dingre {
  width: 100px;
  height: 30px;
  position: absolute;
  top: 0;
  left: 40%;
}

.newstam {
  position: relative;
  height: calc(100vh - 160px);
  min-height: calc(100vh - 160px);
  overflow-y: auto;
  &::-webkit-scrollbar {
    display: inline-block;
  }
  .nstam1 {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
  }

  .nst-d70 {
    width: 70%;
    height: calc(100% - 160px);
    box-sizing: border-box;
    padding-top: 5px;
    position: fixed;
    overflow: hidden;
    background: rgba(4, 39, 71, 0.91);
    top: 160px;
    right: 0;
    z-index: 99;

    .sta-mid {
      height: calc(100% - 118px);
      margin-top: 15px;
      overflow-y: auto;
    }

    .ding-zi {
      box-sizing: border-box;
      padding: 0 20px;
      height: 34px;
      overflow-y: auto;

      &::-webkit-scrollbar {
        display: none
      }
    }

    .nst-top {
      width: 100%;
      height: 58px;
      background-image: url("../assets/img/biaoti.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;

      .msts1 {
        font-size: 24px;
        font-weight: bold;
        font-family: Alibaba PuHuiTi;
        color: white;
        width: 260px;
        text-align: center;
      }

      .msts2 {
        font-size: 24px;
        font-weight: bold;
        font-family: Alibaba PuHuiTi;
        margin-left: 10px;
        color: white;
      }

      .msts3 {
        font-size: 18px;
        color: #A0B8E2;
        margin-left: 10px;
      }

      .msts4 {
        width: 20px;
        height: 20px;
        margin-right: 20px;
        cursor: pointer;
      }

    }
  }

  .nstam2 {
    height: 100%;
    //background: cyan;
    box-sizing: border-box;
    padding-left: 3%;
  }

  .nstam4 {
    box-sizing: border-box;
    padding-left: 3%;
    padding-top: 10px;
  }

  .nstam3 {
    height: 100%;
    box-sizing: border-box;
    padding-top: 10px;

    .nstam3-in {
      width: 100%;
      height: calc(100% - 66px);
      margin-top: 20px;
      //overflow-y: auto;
      overflow: hidden;
      border-radius: 10px;
      box-sizing: border-box;
      padding: 17px;
      background-image: linear-gradient(to top, rgba(7, 32, 59, 0.1), rgba(7, 32, 59, 1)); //从下到上
      .nst-in {
        width: 100%;
        height: 180px;
        margin-bottom: 20px;
      }
    }
  }

  .nstam4 {
    height: 100%;
  }
}

.outpage {
  height: calc(100vh - 80px);
  overflow: hidden;
}

.bm-view {
  width: 100%;
  height: 100%;
}

/deep/ {
  .sformin .el-form-item {
    margin-bottom: 0;
  }

  .sformin .el-input__inner {
    width: 250px;
    height: 27px;
    background: rgba(14, 62, 108, 0.5);
    border-radius: 16px;
    font-size: 14px;
    border: none;
    color: white;
  }

  .sformin .el-form-item__content {
    line-height: 27px;
    //width: 200px;
  }

  .sformin .el-form-item__label {
    height: 27px;
    line-height: 27px;
    color: white;
    font-size: 16px;
  }

  .sformin .el-range-input {
    color: white;
    font-size: 16px;
    background: rgba(14, 62, 108, 0);
  }

  .sformin .el-date-editor .el-range__icon {
    line-height: 23px;
  }

  .sformin .el-range-separator {
    line-height: 20px;
    color: white;
  }

}

.searbtn1 {
  width: 40px;
  height: 27px;
  text-align: center;
  line-height: 27px;
  display: inline-block;
  background: #0090FF;
  border-radius: 13px;
  font-size: 14px;
  color: white;
  margin-right: 10px;
}

.searbtn2 {
  width: 45px;
  height: 27px;
  text-align: center;
  line-height: 27px;
  display: inline-block;
  background: #DCDFE6;
  border-radius: 13px;
  font-size: 14px;
}

#echart1 {
  width: 100%;
  height: 100%;
}

#echart2 {
  width: 100%;
  height: 100%;
}

#echartre {
  width: 100%;
  height: 100%;
}

#echart3 {
  width: 100%;
  height: 100%;
}

#echart4 {
  width: 100%;
  height: 100%;
}

#echart5 {
  width: 100%;
  height: 100%;
}

.newgebwai {
  position: relative;
  z-index: 10;
}

.band1 {
  width: 64px;
  height: 8px;
  position: absolute;
  left: 30px;
  top: 16px;
  z-index: -1;
  background: #0068CB;
}

.gedi6 {
  width: 100%;
  height: calc(100% - 25px);
  position: relative;
}

.gedimap6 {
  width: 100%;
  margin-top: 5px;
  height: calc(100% - 30px);
  position: relative;
  border-radius: 6px;
  overflow: hidden;
}

.gedi66 {
  width: 100%;
  height: calc(100% - 40px);
  margin-top: 15px;
  box-sizing: border-box;
  padding: 0 0 0 20px;
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 0px;
    height: 0px;
    background: transparent;
    display: none;
  }

  .gedi66-1 {
    width: 100%;
    box-sizing: border-box;
    padding: 0 0 13px 20px;
    position: relative;
    border-left: 1px dashed #0886FF;
    font-size: 14px;
    color: #fff;

    &:last-child {
      border-left: none;
    }

    .quan {
      width: 16px;
      height: 16px;
      border-radius: 50%;
      position: absolute;
      left: -8px;
      top: 0;
    }
  }
}

.gedi7 {
  font-size: 14px;
  color: white;
  cursor: pointer;
}

.gedi8 {
  width: 1px;
  height: 24px;
  background: white;
  margin: 0 20px 0 20px;
}

.gedi9 {
  height: calc(100% - 26px);
}

.gedi1 {
  width: 100%;
  height: 48%;
  box-sizing: border-box;
  //background: pink;

  .gedi2 {
    width: 100%;
    height: 100%;

    .gedi3 {
      width: 20px;
      height: 20px;
      margin-right: 10px;
      box-shadow: 0 0 20px 5px rgba(0, 100, 255, 0.5);
    }

    .gedi5 {
      font-size: 10px;
      color: white;
    }
  }
}

.stam2 {
  background-image: url("../assets/img/tj.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  box-sizing: border-box;
  padding: 40px;
  height: 620px;
  margin-top: 20px;

  .stam3 {
    width: 55%;
    height: 100%;
    //background: cyan;
    .stam4 {
      font-size: 28px;
      color: white;

      img {
        width: 35px;
        height: 35px;
        margin-right: 10px;
        box-shadow: 0 0 20px 5px rgba(0, 100, 255, 0.5);
      }
    }
  }

  .stam5 {
    width: 104px;
    height: 13px;
    background: #0068CB;
    margin-top: 15px;
  }

  .stam6 {
    width: 100%;
    margin-top: 10px;
    height: calc(100% - 93px);
    //background: turquoise;
  }
}

.mlogo1 {
  width: 80px;
  height: 80px;
}

.mlp1 {
  font-size: 33px;
}

.mlp2 {
  font-size: 11px;
  letter-spacing: 0 !important;
}


</style>